export default __webpack_public_path__ + "static/TeamOne-f729fa0cf71720e959034488f7fc00ab.webp";